import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../inputs/Button";
import Card from "../shared/Card";

const PanelActions = ({
  status,
  finalReport,
  onMarkDecisionComplete,
  onUploadReport,
  panelId,
}) => {
  const navigate = useNavigate();

  return (
    <Card title="Panel Actions">
      <div className="space-y-3">
        {status === "IN_REVIEW" && (
          <>
            <Button
              variant="primary"
              className="w-full bg-emerald-800 hover:bg-emerald-900"
              onClick={onMarkDecisionComplete}
            >
              Mark Panel Decision Complete
            </Button>
            <Button variant="outline" className="w-full">
              Request Extension
            </Button>
          </>
        )}

        {status === "DECISION_REACHED" && !finalReport && (
          <Button
            variant="primary"
            className="w-full bg-purple-600 hover:bg-purple-700"
            onClick={onUploadReport}
          >
            Upload & Share Final Report
          </Button>
        )}

        {status === "PENDING_PUBLICATION" && (
          <div className="text-center py-4">
            <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <svg
                className="w-6 h-6 text-yellow-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <p className="text-sm text-gray-600">
              Awaiting admin review and publication approval
            </p>
          </div>
        )}

        {status === "PUBLISHED" && (
          <div className="text-center py-4">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <svg
                className="w-6 h-6 text-green-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <p className="text-sm text-gray-600">
              Panel has been published and is publicly visible
            </p>
            <button
              onClick={() => navigate(`/panel/${panelId}`)}
              className="mt-3 text-custom-blue hover:text-custom-light-blue font-medium text-sm"
            >
              View Public Panel →
            </button>
          </div>
        )}

        <Button variant="outline" className="w-full">
          Contact Platform Admin
        </Button>
      </div>
    </Card>
  );
};

export default PanelActions;
